import Step8 from '@/Classes/FollowUp/FollowUpPatint';
export default {
  data() {
    return {
      hasAllergy: null,
      patientDrugAllergy: '',
      patientAllergy: '',
      patientAllergyHistory: new Step8.Step8('', null, null),
      allAllergicItems: [],
      allNotAllergicItems: [],
    };
  },
  methods: {
    addPatientDrugAllergy: function () {
      if (!this.patientDrugAllergy) {
        this.showErrorAlert('حساسیت دارویی نمی تواند خالی باشد');
        return;
      }
      if (!this.patientDrugAllergy.replace(/\s/g, '').length) {
        this.showErrorAlert('حساسیت دارویی نمی تواند خالی باشد');
        return;
      }
      this.patientAllergyHistory.isAllergic = true;
      this.patientAllergyHistory.patientId = this.patientId;
      this.patientAllergyHistory.title = this.patientDrugAllergy;
      this.addPatientAllergyHistoryFunction(this.patientAllergyHistory);
    },
    addPatientAllergy: function () {
      if (!this.patientAllergy) {
        this.showErrorAlert('حساسیت دارویی نمی تواند خالی باشد');
        return;
      }
      if (!this.patientAllergy.replace(/\s/g, '').length) {
        this.showErrorAlert('حساسیت دارویی نمی تواند خالی باشد');
        return;
      }
      this.patientAllergyHistory.isAllergic = false;
      this.patientAllergyHistory.patientId = this.patientId;
      this.patientAllergyHistory.title = this.patientAllergy;
      this.addPatientAllergyHistoryFunction(this.patientAllergyHistory);
    },
    patientAllergyHistoryAdded: function () {
      this.patientAllergy = '';
      this.patientDrugAllergy = '';
    },
    setData: function (data) {
      if (data.length > 0) {
        this.hasAllergy = true;
      }
      this.allAllergicItems = [];
      this.allNotAllergicItems = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].isAllergic == true) {
          this.allAllergicItems.push(data[i]);
        } else {
          this.allNotAllergicItems.push(data[i]);
        }
      }
    },
    goToNextStep: function () {
      this.$root.$refs.FollowUpPatient.changeTab(3);
      this.$root.$refs.FollowUpPatient.changeTab3Step(1, true);
    },
    backToStep7: function () {
      this.$root.$refs.FollowUpPatient.changeTab2Step(3, true);
    },
  },
};
